export default __webpack_public_path__ + "static/media/film.f573aeb0.jpg";